// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"264": "6960c69d","8632": "8ea63f68","993": "66d99147",}[chunkId] + ".css"
}